import { render, staticRenderFns } from "./WikiNavigation.vue?vue&type=template&id=4196650c&"
import script from "./WikiNavigation.vue?vue&type=script&lang=js&"
export * from "./WikiNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports